// LIBS
import React from 'react'

// COMPONENTS
import EventCalendarItem from '../event-calendar-item/index.js'

// INTERFACE
class EventCalendarItems extends React.Component {
  render () {
    const { events } = this.props
    return (
      <div className="event-calendar-items">
        {events.length
          ? events.map((e, i) => <EventCalendarItem key={i} event={e} />)
          : <h1>No events found</h1>
        }
      </div>
    )
  }
}

export default EventCalendarItems



// WEBPACK FOOTER //
// ./src/components/event-calendar-item-list/index.js